import data from '../../../../shared/standards/iso27001.json';
export default data;
